export default {
  h1_services: "Services d'intelligence artificielle pour les médecins",
  Services: "Produits",
  eduServices: "Cours",
  AIServices: "Services IA",
  mg: "Mammographie",
  dx: "Radiographie thoracique",
  // rf: "Radiographie thoracique",
  "Go to service": "Essayer",
  "Service banner text":
    "Calculez les économies de coûts réalisées grâce à l'IA dans votre établissement",
  Calc: "Essayer",
  "Services title": "Produits | «Third Opinion»",
  "No description service": "Description non trouvée",
  "Services cannot loading":
    "Service temporairement indisponible. Réessayez plus tard.",
  "Cash calc title": "Calculateur de coûts | «Third Opinion»",
  "Cash calc": "Calculateur de coûts",
  "Cash calc desc": "Combien d'économies pouvez-vous réaliser grâce à l'IA ?",
  "Cash calc desc about":
    "Saisissez les données de votre établissement. Elles seront supprimées après avoir quitté la calculatrice.",
  "Average cash": "Salaire moyen d'un radiologue par mois",
  "Study calc count": "Nombre d'études dans votre établissement par mois",
  mmg: "Mammographie",
  ddx: "Radiographie thoracique",
  ct: "Scanner thoracique",
  "Start calc": "Calculer",
  economy: "Économies",
  rub: " €",
  "calc time": " h",
  "Calc summary": "Total annuel",
  "Without AI": "Sans IA",
  "With AI": "Avec l'IA",
  "Count calc short": "Nombre annuel de ",
  "Calc in Year": "",
  "Calc item 1": "Temps de lecture <br /> par étude, min",
  "Calc item 2": "Coût de lecture <br /> par étude, $",
  "Calc item 3": "Coûts de lecture <br />",
  "Calc item 4": "Temps de lecture,<br />h",
  mmg__count: "MMG",
  ddx__count: "CXR",
  ct__count: "CT",
  "Calc info": "Méthodologie de calcul",
};
